export enum NotificationTypeEnum {
  NOTHING,
  ERROR,
  WARNING,
}

export const translateKey = (value: string): string => {
  return "notification.type." + value.toLowerCase();
};
